import config from '@/config';
import { ApiBase, InternationalizedField } from '@/api/common';
import { isEmpty } from 'lodash';

const NO_UPLOAD_FIELDS = [
  'path',
  'public_url',
  'meta',
  'mime',
  'status',
  'public_url_expiration',
  'file',
  'state'
];

export default class Video extends ApiBase<Video> {
  public static readonly SLUG: string = 'media-video';
  private static readonly URL_BASE: string = config.API_ROOT + '/media-video/';

  // Initializing these fields (even with undefined)
  // is necessary, so hasOwnAttribute can find them.
  public path?: string = undefined;
  public public_url?: string = undefined;
  public meta?: string = undefined;
  public mime?: string = undefined;
  public status?: string = undefined;
  public public_url_expiration?: string = undefined;
  public type?: string = 'youtube';
  public url?: string = undefined;
  public start_time?: string = undefined;
  public end_time?: string = undefined;
  public order?: number = undefined;
  public parent_id?: number = undefined;
  public parent_model?: string = undefined;
  public display_condition?: string = undefined;
  public tags?: string[] = [];
  public thumbnail_url?: string = undefined;
  public title?: string = undefined;
  public description?: InternationalizedField<string> = new InternationalizedField<string>();
  public promoted?: boolean = undefined;
  public interface_elements?: string = undefined;

  // used to know if the hint is being created, was updated or is saved
  public state?: string = 'created';
  public file?: File = undefined;

  // currently unused
  public spreadsheet?: string = undefined;

  public constructor() {
    super({
      urlBase: Video.URL_BASE,
      filteredFields: NO_UPLOAD_FIELDS
    });
  }

  public assign(response: any): Video {
    super.assign(response);
    if (response) {
      if ('tags' in response) {
        this.tags = [];
        if (!isEmpty(response.tags)) {
          response.tags.forEach((tag: any) => {
            this.tags.push(tag);
          });
        }
      }

      if ('description' in response) {
        this.description = new InternationalizedField<string>(
          response.description
        );
      }
    }
    this.state = 'unchanged';
    return this;
  }

  public async save(): Promise<number> {
    await this.saveTags();
    return super.save();
  }

  public async saveTags() {
    if (this.tags && this.tags.length === 0) {
      if (!this.id) {
        return delete this.tags;
      } else {
        this.tags = [];
      }
    }
  }
}
